import * as actionTypes from '../types/user';

const initialState = {
  id: null,
  username: null,
  fullname: null,
  logoutLoading: false,
  logoutError: false,
  logout: false,
  userInfo: null,
  corporate: null,
  userInfoError: false,
  permissions: [],
  messageIconCount: 0,
  infoMessing: {
    text: null,
    visible: false
  },
  isConsentVisible: false
};

if (window.localStorage.getItem('userInfo')) {
  const data = JSON.parse(window.localStorage.getItem('userInfo'));
  // if (data.username.match('^[A-Za-z._]+$')
  // && !data.username.StartsWith('.')
  // && !data.username.StartsWith('_')
  // && !data.username.EndsWith('.')
  // && !data.username.EndsWith('_')
  // && !data.username.Contains('..')
  // && !data.username.Contains('__')
  // && !data.username.Contains('._')
  // && !data.username.Contains('_.')) {
  //   initialState.username = data.username;
  // }
  initialState.username = data.username;
  if (data.id !== null && data.id.toString().match('^[0-9]{1,}$')) {
    initialState.id = data.id;
  }
  initialState.logoutLoading = data.logoutLoading;
}

if (window.localStorage.getItem('theme')) {
  initialState.theme = window.localStorage.getItem('theme');
} else {
  initialState.theme = 'material.blue.light';
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.USER_MESSAGE_INFO_VISIBLE_OPEN:
      return {
        ...state,
        infoMessing: {
          ...state.infoMessing,
          visible: true
        }
      };
    case actionTypes.USER_MESSAGE_INFO_VISIBLE_CLOSE:
      return {
        ...state,
        infoMessing: {
          ...state.infoMessing,
          visible: false
        }
      };
    case actionTypes.USER_SET_MESSAGE_ICON_COUNT:
      return {
        ...state,
        messageIconCount: payload
      };
    case actionTypes.USER_INFO:
      return {
        ...state,
        id: payload.id,
        username: payload.username,
        fullname: payload.fullname,
        logout: false,
        logoutLoading: false,
        userInfo: null
      };

    case actionTypes.USER_LOGOUT_REQUEST:
      return {
        ...state,
        logoutLoading: true,
        logoutError: false,
        logout: false
      };

    case actionTypes.USER_LOGOUT_SUCCESS:
      return {
        ...state,
        logoutLoading: false,
        logout: true
      };

    case actionTypes.USER_LOGOUT_FAIL:
      return {
        ...state,
        logoutLoading: false,
        logoutError: true,
        logout: false
      };

    case actionTypes.USER_GET_INFO:
      return {
        ...state,
        userInfo: null,
        userInfoError: false
      };

    case actionTypes.USER_GET_INFO_SUCCESS:
      return {
        ...state,
        userInfo: payload,
        username: payload.username,
        id: payload.id,
        fullname: payload.fullname
      };

    case actionTypes.USER_GET_INFO_FAIL:
      return {
        ...state,
        userInfo: false,
        userInfoStatus: payload?.status,
        userInfoError: (payload?.data)
          ? (payload?.data)
          : (payload)
      };

    case actionTypes.USER_GET_INFO_CLEAR:
      return {
        ...state,
        userInfoError: false
      };

    case actionTypes.USER_CORPORATE:
      return {
        ...state,
        corporate: null
      };

    case actionTypes.USER_CORPORATE_SUCCESS:
      return {
        ...state,
        corporate: payload
      };

    case actionTypes.USER_CORPORATE_FAIL:
      return { ...state };

    case actionTypes.USER_SET_THEME:
      return {
        ...state,
        theme: payload
      };

    case actionTypes.USER_GET_PERMISSIONS_REQUEST:
      return { ...state };

    case actionTypes.USER_GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: payload
      };

    case actionTypes.USER_GET_PERMISSIONS_FAIL:
      return {
        ...state,
        permissions: []
      };

    case actionTypes.USER_CONSENT_NEED_REQUEST:
      return {
        ...state,
        isConsentVisible: false
      }

    case actionTypes.USER_CONSENT_NEED_SUCCESS:
      return {
        ...state,
        isConsentVisible: payload
      }

    case actionTypes.USER_CONSENT_NEED_FAIL:
      return {
        ...state,
        isConsentVisible: payload
      }

    case actionTypes.USER_CONSENT_SAVE_REQUEST:
      return {
        ...state
      }

    case actionTypes.USER_CONSENT_SAVE_SUCCESS:
      return {
        ...state,
        isConsentVisible: false
      }

    case actionTypes.USER_CONSENT_SAVE_FAIL:
      return {
        ...state,
        isConsentVisible: true
      }

    default:
      return state;
  }
};

export default reducer;
